@if(!status || status.busy) {
@switch(variant) {
<!-- @case('media') {
        <ng-container *ngTemplateOutlet="mediaTemplate"></ng-container>
    } -->
@default {
<ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
}
}
}

@if(status && status.error) {
<p class="'p2 col-2 m-t">{{status.error}}</p>
}

<!-- TEMPLATES -->

<ng-template #defaultTemplate>
    @for(_ of lines; track $index) {
    <div class="b-rad m-t _line _waveBackgroundEffect"
         [style.height]="height">
    </div>
    }
</ng-template>

<!-- <ng-template #mediaTemplate>
    <div [dfs]="'d:grid'"
         [style.columnGap.px]="8"
         [style.rowGap.px]="8"
         [style.gridTemplateColumns]="'repeat('+numberOfColumns+', minmax(0, 1fr))'">
        <ng-container *ngFor="let _ of squares">
            <div>
                <div class="_square _waveBackgroundEffect">
                </div>
                <div class="_line _waveBackgroundEffect"
                     [dfs]="'m-t:2 br:50'"></div>
            </div>
        </ng-container>
    </div>
</ng-template> -->